import { useCallback } from "react";
import { useUserTimezone } from "@/hooks/useUserTimezone";
import { formatDateTimeInTimeZone } from "@/utils/date";

export const useFormattedDateTime = () => {
  const userTimezone = useUserTimezone();

  return useCallback(
    (dateTime: unknown) => {
      return formattedDateTime(dateTime, userTimezone);
    },
    [userTimezone]
  );
};

export const formattedDateTime = (dateTime: unknown, userTimezone: string) => {
  return formatDateTimeInTimeZone(dateTime, userTimezone);
};
